import * as Factory from 'factory.ts'
import faker from 'faker'

import { PrimaryCategoryApiModelStub } from '@webapp/core/data-access/api-models/stubs/PrimaryCategoryApiModel.stub'
import { UserApprovalDelegateeApiModelStub } from '@webapp/core/data-access/api-models/stubs/UserApproverDelegateeApiModel.stub'
import { type UserApiModel } from '@webapp/platform/iam/data-access/api-models/UserApiModel'
import { UserTiers } from '@webapp/platform/iam/entities/enums/UserTierEnum'
import { UserRoleApiModelStub } from './UserRoleApiModel.stub'

export const UserApiModelStub = Factory.Sync.makeFactory<UserApiModel>({
  id: Factory.each(() => faker.random.number()),
  user: Factory.each(() => faker.random.number()),
  firstName: Factory.each(() => faker.name.firstName()),
  lastName: Factory.each(() => faker.name.lastName()),
  email: Factory.each(() => faker.internet.email()),
  location: PrimaryCategoryApiModelStub.build(),
  profile_image: Factory.each(() => 'https://i.pravatar.cc/150'),
  is_active: Factory.each(() => faker.random.boolean()),
  position: Factory.each(() => faker.name.jobTitle()),
  role: UserRoleApiModelStub.build(),
  approval_delegatee: UserApprovalDelegateeApiModelStub.build(),
  expected_return_date: Factory.each(() => faker.date.future().toISOString()),
  user_tier: Factory.each(() =>
    faker.random.arrayElement(Object.values(UserTiers))
  ),
})
